export const REDUCER_NAME="categorieSlice";

// Interface for a single category
export interface iCategory {
    id: string;
    vendor_id: string;
    name: string;
    slug: string;
    parent_id: string;
    display_type: string;
    description: string;
    image_url: string | null;
    created_at: string;
    updated_at: string;
  }
  
  export interface iCategoryState {
    isLoading: boolean;
    category: iCategory | null; // A single category object
    errorMessage: string | null;
    categoryList: []; // An array of categories
  }
  